import React, { Component } from 'react';
import './DashboardFooter.css';

class DashboardFooter extends Component {
	render(){
		return(
			<div className="dashboard-footer">
			<h2>Need help with something?</h2>
			<a href="mailto:info@fmeasure.com">info@fmeasure.com</a>
			</div>
			)
	}
}

export default DashboardFooter;


// WEBPACK FOOTER //
// ./src/components/DashboardHome/DashboardFooter/DashboardFooter.js